import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { LpCanvasService } from '@core/lp/lp-canvas.service';
import { LpCanvasRendererComponent } from '@features/lp/lp-canvas/lp-canvas-renderer/lp-canvas-renderer.component';
import { workaroundCanvasRatio } from '@shared/workarounds.utils';
import { LpCanvasActivity, LpCanvasElement } from '@typings/lp/generated';

@Component({
  selector: 'lp-canvas-activity',
  imports: [LpCanvasRendererComponent],
  templateUrl: './lp-canvas-activity.component.html',
  styleUrl: './lp-canvas-activity.component.css',
})
export class LpCanvasActivityComponent {
  readonly #lpCanvasService = inject(LpCanvasService);

  activity = input.required<LpCanvasActivity>();
  elements = signal<LpCanvasElement[]>([]);
  size = computed(() => workaroundCanvasRatio(this.activity().canvasRatio));

  constructor() {
    effect(async () => {
      this.#lpCanvasService.subscribeToShowIfChanges();

      this.elements.set([
        this.#lpCanvasService.convertBackgroundToElement(this.activity().background, this.size()),
        ...this.activity().canvasElements,
      ]);
    });
  }
}
